import React from 'react';
import {CheckboxInput} from '~/components/Controls/Checkbox';
import {Input, InputType} from '~/components/Controls/Input';
import {SelectInput} from '~/components/Controls/Select';
import {TagsInput} from '~/components/Controls/Tags';
import {IAttributeInfo, IAttributeValue, IRule, IType} from '~/modules/Bidders/models/Rule';
import style from './PreTargetingRules.module.scss';

interface IAttributeValueProps {
    rule: IRule;
    attribute: IAttributeInfo;
    variables: string[];
    onChange: (value: IAttributeValue) => void;
}

export const AttributeValue = ({variables, rule, attribute, onChange}: IAttributeValueProps) => {
    if (rule.variable) {
        return <SelectInput items={variables.map(variable => ({label: variable, value: variable}))} value={rule.value}
            onChange={onChange}/>;
    } else {
        switch (attribute.type) {
            case IType.Bool:
                return <CheckboxInput value={rule.value} onChange={() => onChange(!rule.value)} toggle/>;
            case IType.Numeric:
                return <Input value={rule.value} type={InputType.INTEGER} onChange={onChange}/>;
            case IType.String:
                return Array.isArray(rule.value) ?
                    <TagsInput value={rule.value} onChange={onChange}/> :
                    <Input value={rule.value} onChange={onChange}/>;
            default:
                return <div className={style.value}>Unsupported type: {attribute.type}</div>;
        }
    }
};
